import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Link, useHistory } from 'react-router-dom';
import Alert from '../Alert';

const Dashboard = () => {
  const { currentUser, logout } = useAuth();

  const history = useHistory();

  const [error, setError] = useState('');

  const handleLogout = async () => {
    setError('');
    try {
      await logout();
      history.push('/login');
    } catch (err) {
      setError(err);
    }
  };

  return (
    <div style={{ textAlign: 'center' }}>
      {error && <Alert variant="error">{error}</Alert>}
      <p>
        <strong>Logged in as: </strong>
        {currentUser.email}
      </p>
      <Link to="/update-profile">
        <button className="btn cta-button">Update Profile</button>
      </Link>
      <br />
      <button onClick={handleLogout} className="btn">
        Log out
      </button>
    </div>
  );
};

export default Dashboard;
